// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1gnOcX2kzjwAmJytoLZAux {\n  fill: currentColor;\n}\n", ""]);
// Exports
exports.locals = {
	"Icon": "_1gnOcX2kzjwAmJytoLZAux"
};
module.exports = exports;
